package com.essntl.uikit.components.tooltip

import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier

@Composable
fun EsTooltip(
    text: String,
    modifier: Modifier = Modifier,
    content: @Composable () -> Unit,
) = EsTooltipPlatform(
    text = text,
    modifier = modifier,
    content = content,
)

@Composable
internal expect fun EsTooltipPlatform(
    text: String,
    modifier: Modifier = Modifier,
    content: @Composable () -> Unit,
)